import { Injectable } from '@angular/core';
import {StudentClass} from '../models/applicationFeature';
import {CommonService} from './common.service';
import {ToastMessagesService} from './toast-messages.service';

@Injectable({
  providedIn: 'root'
})
export class StudentClassService {

  constructor(public commonService: CommonService,
              public toastMessagesService: ToastMessagesService) { }

  async initClasses(): Promise<StudentClass[]> {
    const studentClasses: StudentClass[] = [];
    try {
      const classesRequest = await this.commonService.getList(`class`);
      for (const studentClass of classesRequest.object) {
        const childrenRequest = await this.commonService.getList(`children/class?classId=${studentClass.id}`);
        const children = childrenRequest.object;
        const classLength = childrenRequest.object.length;
        const model: StudentClass = {
          class: studentClass,
          children,
          classLength
        };
        studentClasses.push(model);
      }

      return studentClasses;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
